module.exports = __webpack_public_path__ + "img/link.3684dd7f.svg";